'use client';


/** Imports */
import classNames from 'classnames';
import React, {useEffect} from 'react';
import {useTranslations} from 'next-intl';
import styles from './ErrorBoundary.module.css';


/** Types */
export type RouteSegmentErrorProps = Readonly<{
    error: Error & {digest?: string};
    reset: () => void;
}>;


/** Component */
export default function RouteSegmentError(props: RouteSegmentErrorProps) {
    const {error, reset} = props;

    // Hooks
    const t = useTranslations('common');

    // Effects
    useEffect(() => {
        console.error(error);
    }, [error]);


    // Render
    return (
        <div role="alert" className={styles.errorFallback}>
            <div>
                <div className={styles.headline}>
                    {t('errorBoundary.headline')}
                </div>
                <pre className={styles.errorMessage}>
                   {(process.env.NODE_ENV === 'development')
                       ? (error.message || t('errorBoundary.message'))
                       : t('errorBoundary.message')}
                </pre>
                <button
                    type="button"
                    className={classNames(styles.tryAgainButton, 'button')}
                    onClick={reset}
                >
                    {t('errorBoundary.buttonRetry')}
                </button>
            </div>
        </div>
    );
}
